/**
 * Created by Languagenut on 16/04/2019.
 */

import React  from 'react';

import {ProgressBar} from 'react-bootstrap'
import UserService from '../../services/user-service.js';
import UserStore from '../../store/user-store.js';
import Constants from '../../constants.js';
import Translation from '../../store/internationalization-store.js';
import Table from '../general_table.js';

export default class Messages extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            toggle:false,
            messages:[],
            archivedLanguages:[],
            hasLoaded:false
        };
    }

    componentWillMount(){

        UserStore.on(Constants.GET_STUDENT_MESSAGES , ()=>{
            this.setState({
                messages:UserStore.messages|| [],
                hasLoaded:true
            })
        })
    }

    componentDidMount(){
        UserService.getStudentMessages(this.props.studentUid);
    }

    renderAvailability(cell, row){
        return <div>{(new Date(cell.replace(" ", "T"))).format('d-m-y')}</div>
    }

    render(){

        if (!this.state.hasLoaded) {
            return <ProgressBar animated now={45}/>;
        }

        const columns = [
        {
            dataField: 'title',
            text: Translation.get(2202 , 'Title'),
            sort:true,
            searchable: true,
        },{
             dataField: 'message',
             text: Translation.get(12319 , 'Message'),
             sort:true,
             searchable: false,
         },{
             dataField: 'created_by_name',
             text: Translation.get(2421 , 'Created by'),
             searchable: false,
             headerStyle: (colum, colIndex) => {
                return { width: '150px', textAlign: 'left' };
             }
         },{
             dataField: 'created_date',
             text: Translation.get(2422 , 'Created date'),
             align:'left',
            sort:true,
             formatter: this.renderAvailability.bind(this),
            searchable: false,
            headerStyle: (colum, colIndex) => {
                return { width: '125px', textAlign: 'left' };
             }
         }];

        return <div>
            <div>
                <Table hideDownload secondary={""} component={""} bordered={ true } key='id' data={this.state.messages} columns={ columns } />
            </div>
        </div>
    }
}
